module.exports = __webpack_public_path__ + "img/15.1594f558.gif";